import { _, Obscura } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Location from "../models/Location";

const LocationsProxy = Obscura.extend({
  filterByQuery(val) {
    return this.filterBy("query", (model) => {
      return model.get("id") === parseInt(val) || model.get("name").toLowerCase().startsWith(val);
      //  || model.get('description').toLowerCase().indexOf(val) >= 0
    });
  },
});

export default InboomaBaseAsyncCollection.extend({
  collectionName: "locations",
  model: Location,
  url: "/locations?find=short",
  proxy: LocationsProxy,

  _pagination: {
    current_page: 0,
    sort: "name",
    sortDirection: "asc",
    has_next_page: false,
    has_prev_page: false,
    count: 0,
    limit: 999, // Set pagination to unlimited
  },
});
